export default [

     {
          path: '/third-party-contract',
          name: 'ThirdPartyContract',
          component: () => import("@/views/Page/ThirdPartyContract/ThirdPartyContract.vue"),
           meta: {
               title: 'ThirdPartyContract',
          },
     }
];